import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon from '@deprecated-ui/common/Iconmoon';

function OverLimitText({ isRight }: { isRight: boolean }) {
  return (
    // @ts-expect-error
    <Flex ml="180px">
      <Iconmoon size="20px" className="icon-toolbar_error" />
      {/* @ts-expect-error */}
      <Text size="13px" color="red" ml="3px" mb="10px">
        Nilai pembelian kamu tidak dapat diproses karena melebihi{' '}
        {isRight ? 'cash on hand' : 'trading limit'}
      </Text>
    </Flex>
  );
}

export default OverLimitText;
